module.exports = __webpack_public_path__ + "img/inspiration_styles@2x.0545362.jpg";